import React from 'react';
import { Icon } from '@iconify/react';

function InstagramSection({
  instagramName,
  setInstagramName,
  registeredUsers,
  onRegister,
  onSyncNow,
  onToggleStatus, // 🌟 SettingsPageから受け取った関数
  syncingUser,
  loading
}) {
  return (
    <div id="instagram" className="mb-4 pb-3">
      <h4 className="d-flex align-items-center mb-2 mt-3">
        <Icon className="iconify fs-24px me-2 text-pink-500 my-n1" icon="solar:camera-bold-duotone" />
        Instagram 連携
      </h4>
      <p>ECサイトに最新投稿を埋め込むための、監視対象アカウントを設定します。</p>

      {/* アカウント追加フォーム */}
      <div className="card mb-4">
        <div className="card-body bg-light">
          <form onSubmit={onRegister}>
            <div className="row align-items-end">
              <div className="col-md-8">
                <label className="form-label fw-bold">取得対象のInstagramユーザー名 (@なし)</label>
                <div className="input-group">
                  <span className="input-group-text bg-white">@</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={instagramName}
                    onChange={(e) => setInstagramName(e.target.value)}
                    disabled={loading}
                    required
                  />
                </div>
              </div>
              <div className="col-md-4 mt-3 mt-md-0">
                <button
                  type="submit"
                  className="btn btn-theme w-100 d-flex align-items-center justify-content-center"
                  disabled={loading || !instagramName.trim()}
                  style={{ background: 'linear-gradient(to right, #ec4899, #8b5cf6)', border: 'none' }}
                >
                  <Icon icon="solar:download-square-bold" className="fs-18px me-2" />
                  登録 ＆ 初回インポート
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* 監視対象リスト */}
      <h5 className="mb-3 fs-14px">現在監視中のアカウント一覧</h5>
      <div className="card">
        {registeredUsers.length === 0 ? (
          <div className="card-body text-center text-muted py-5">
            登録されているアカウントはありません。上のフォームから追加してください。
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover table-borderless table-striped mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  <th className="pt-3 pb-3 ps-4">アカウント名</th>
                  <th className="pt-3 pb-3">フォロワー数</th>
                  <th className="pt-3 pb-3">最終同期日時</th>
                  <th>公開設定</th>
                  <th className="pt-3 pb-3 text-end pe-4">アクション</th>
                </tr>
              </thead>
              <tbody>
                {registeredUsers.map((user) => (
                  <tr key={user.instagram_name}>
                    <td className="ps-4 fw-bold">
                      <span className="text-pink-500 me-1">@</span>{user.instagram_name}
                    </td>
                    <td className="text-muted">{user.followers_count.toLocaleString()} 人</td>
                    <td className="text-muted fs-12px">{user.updated_at || '未同期'}</td>

                    <td>
                      {/* 🌟 公開・非公開切り替えトグルスイッチ */}
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={user.is_public}
                          onChange={() => onToggleStatus(user.instagram_name, user.is_public)}
                          style={{ cursor: 'pointer' }}
                        />
                        <label className="form-check-label text-muted small">
                          {user.is_public ? '公開中' : '非公開'}
                        </label>
                      </div>
                    </td>

                    <td className="text-end pe-4">
                      <button
                        type="button"
                        onClick={() => onSyncNow(user.instagram_name)}
                        disabled={syncingUser === user.instagram_name}
                        className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
                      >
                        <Icon
                          icon="solar:restart-bold"
                          className={`fs-16px me-1 ${syncingUser === user.instagram_name ? 'fa-spin text-primary' : ''}`}
                        />
                        {syncingUser === user.instagram_name ? '同期中...' : '今すぐ同期'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="alert bg-warning bg-opacity-10 text-danger mt-3 mb-0">
        <i className="fa fa-info-circle me-2"></i>
        <b>運用上の注意:</b> 「今すぐ同期」を押すと、毎回Instagram APIを叩いて強制更新します。通常は毎晩の全自動巡回に任せておいてください。
      </div>
    </div>
  );
}

export default InstagramSection;